import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "fundelarento_cookie_consent_v1";

const applyConsent = (granted) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const state = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
};

const CookieBanner = () => {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    } else {
      try {
        const parsed = JSON.parse(stored);
        applyConsent(parsed.granted === true);
      } catch (_) {
        setVisible(true);
      }
    }
  }, []);

  const decide = (granted) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ granted, ts: Date.now() }));
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  const cookiesLink = lang === "mx" ? "/mx/cookies" : "/en/cookies";

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-4 border-[#0B2545] shadow-2xl"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col lg:flex-row items-start lg:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="w-10 h-10 rounded-md bg-[#F8FAFC] border border-slate-200 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-[#0B2545]" />
          </span>
          <div>
            <h3 className="font-serif font-bold text-[#0B2545] text-lg leading-tight" data-testid="cookie-banner-title">
              {t("cookie_banner.title")}
            </h3>
            <p className="text-sm text-[#475569] mt-1 leading-relaxed">
              {t("cookie_banner.body")}{" "}
              <Link to={cookiesLink} className="underline text-[#0B2545] font-medium" data-testid="cookie-banner-policy-link">
                {t("cookie_banner.settings_link")}
              </Link>
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          <button
            onClick={() => decide(false)}
            className="px-5 py-2.5 text-sm font-semibold rounded-md border-2 border-slate-300 text-[#0B2545] hover:bg-slate-50"
            data-testid="cookie-decline-button"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            onClick={() => decide(true)}
            className="px-5 py-2.5 text-sm font-semibold rounded-md bg-[#134E4A] text-white hover:bg-[#0f3f3c]"
            data-testid="cookie-accept-button"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
